package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class EventMatch<M : MetricsAPI<Short>>(
    val code: String,
    val event: String,
    val level: Schedule.Match.Level,
    val series: Int,
    val number: Int,
    val redTeams: List<Schedule.Team>,
    val blueTeams: List<Schedule.Team>,
    val redResult: M?,
    val blueResult: M?,
)
